<template>
	<div class="parent">
		<div class="scroll">
			<table :key=updateKey>
				<tr>
					<td v-if="column_data_a!=null" style="vertical-align:top">
						<div id="div_a" style="height:calc(100vh - 150px); overflow-y:auto;"><table>
							<thead>
								<tr>
									<th class="table-header" style="text-align:center">
										{{name_a}}
									</th>
								</tr>
							</thead>
							<tbody v-if="term=='0'">
								<tr v-for="(column, col) in column_data_a">
									<td style="width:100%">
										<button v-on:click="editRole(col)" style="width:50px">Edit</button>
										<button v-if="col==selection" style="width:calc(100% - 60px); float:right;" disabled>{{column[1]}}</button>
										<button v-else style="width:calc(100% - 60px); float:right;" v-on:click="select(col,0)">{{column[1]}}</button>
									</td>
								</tr>
								<tr>
									<td style="width:100%">
										<button v-on:click="editRole(0)" style="width:100%">+</button>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr v-for="(column, col) in column_data_a">
									<td style="width:100%">
										<button v-if="col==selection" style="width:100%;" disabled>{{column[1]}}</button>
										<button v-else style="width:100%;" v-on:click="select(col,0)">{{column[1]}}</button>
									</td>
								</tr>
							</tbody>
						</table></div>
					</td><td v-if="column_data_b!=null" style="vertical-align:top">
						<div id="div_b" style="height:calc(100vh - 150px); overflow-y:auto;"><table>
							<thead>
								<tr>
									<th colspan=2 class="table-header" style="text-align:center">
										{{name_b}}
									</th>
								</tr>
							</thead>
							<tbody v-if="term=='3'">
								<tr v-for="(column, col) in column_data_b" >
									<td style="width:calc(100% - 110px)" v-on:click="selectText(col,1)">
										<input type="checkbox" v-model="column[2]" style="width:50px; float:left;"></input>
										<p style="float:left; margin:0px;">{{column[1]}}</p>
									</td>
									<td style="width:100px">
										<input
										type="text"
										v-model="column[3]"
										style="width:100px; float:right;"
										v-on:blur="selectText(col,1,column[3])"
										@keydown.enter="selectText(col,1,column[3])"></input>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr v-for="(column, col) in column_data_b">
									<td style="width:100%;" v-on:click="select(col,1)">
										<input type="checkbox" v-model="column[2]" style="width:50px; float:left;"></input>
										<p style="float:left; margin:0px;">{{column[1]}}</p>
									</td>
								</tr>
							</tbody>
						</table></div>
					</td><td v-if="column_data_c!=null" style="vertical-align:top;">
						<div id="div_c" style="height:calc(100vh - 150px); overflow-y:auto;"><table>
							<thead>
								<tr>
									<th class="table-header" style="text-align:center">
										{{name_c}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(column, col) in column_data_c">
									<td style="width:100%" v-on:click="select(col,2)">
										<input type="checkbox" v-model="column[2]" style="width:50px; float:left;"></input>
										<p style="float:left; margin:0px;">{{column[1]}}</p>
									</td>
								</tr>
							</tbody>
						</table></div>
					</td>
				</tr>
			</table>
		</div>

		<dialogue
		:title="'Edit Role'"
		:paragraph="edit_dialogue_text"
		:button_names="['Accept']"
		:show="edit_dialogue"
		:autoClose="false"
		:html="edit_html"
		v-on:dialogue="editDialogue"
		v-on:cancel="editDialogueCancel"
		></dialogue>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term:0,
		page:0,
		height:0,
		roleEditPage:0,
    },
	data() {
		return {
			updateKey:0,
			perms:[],
			name_a:'Role',
			column_data_a:null,
			selection:0,
			name_b:'User',
			column_data_b:null,
			name_c:'Permission',
			column_data_c:null,

			edit_dialogue:false,
			edit_dialogue_text:'',
			edit_html:'',
			edit_html_placeholder:'<input id="editText" style="width:100%;" \{{0}}></input>',
			edit_value:0,
		}
	},
	async created () {
		this.perms = api.getPerms();

		var getPage = parseInt(api.getCookie("page_"+this.id))
		if(getPage!=null && getPage!=undefined && !isNaN(getPage)) { this.page = getPage }

		if(this.term==0) {
			this.name_a = 'Role'
			this.name_b = 'User'
			this.name_c = 'Permission'
		}else if(this.term==1) {
			this.name_a = 'User'
			this.name_b = 'Role'
			this.name_c = ''
		}else if(this.term==2) {
			this.name_a = 'Permission'
			this.name_b = 'Role'
			this.name_c = ''
		}else if(this.term==3) {
			this.name_a = 'Lock'
			this.name_b = 'Permission'
			this.name_c = ''
		}

		this.search()
	},
	methods: {
		async search (){
			if(this.column_data_a==null){
				this.column_data_a = []
				this.column_data_a[this.selection]=[]
				this.column_data_a[this.selection][0]=-1
			}

			api.postData(
                {
                    type:"search",
                    data:{
						pageid:this.page,
						term:this.column_data_a[this.selection][0],
					}
                }
            ).then((res) => {
				if(res.data.a.data!=null && res.data.a.data.column_data!=null){
		            this.column_data_a = res.data.a.data.column_data
				}else{
					this.column_data_a=null
				}
				if(res.data.b.data!=null && res.data.b.data.column_data!=null){
		            this.column_data_b = res.data.b.data.column_data
					for(let i = 0;i<this.column_data_b.length;i++){
						if(this.column_data_b[i][2]==0){
							this.column_data_b[i][2] = false
						}else{
							this.column_data_b[i][2] = true
						}
					}
				}else{
					this.column_data_b=null
				}
				if(res.data.c.data!=null && res.data.c.data.column_data!=null){
		            this.column_data_c = res.data.c.data.column_data
					for(let i = 0;i<this.column_data_c.length;i++){
						if(this.column_data_c[i][2]==0){
							this.column_data_c[i][2] = false
						}else{
							this.column_data_c[i][2] = true
						}
					}
				}else{
					this.column_data_c=null
				}

				this.update()
	        })
		},
        async select (index, table){

			var value = false
			var id = 0

			if(table==0){
				this.selection = index
				this.search();
			}else if(table==1){
				value = !this.column_data_b[index][2]
				id = this.column_data_b[index][0]
				this.column_data_b[index][2] = value
			}else if(table==2){
				value = !this.column_data_c[index][2]
				id = this.column_data_c[index][0]
				this.column_data_c[index][2] = value
			}

			this.update()

            api.postData(
                {
                    type:"insert",
					data:{
						pageid:this.page,
						data:[
							this.column_data_a[this.selection][0],
							id,
							table,
							value,
						],
					}
                }
            ).then((res) => {

            })
        },
		async selectText(index,table,text){

			var value = false
			var id = this.column_data_b[index][0]

			if(text==undefined){
				value = !this.column_data_b[index][2]
				this.column_data_b[index][2] = value
				text = this.column_data_b[index][3]
			}else{
				value = this.column_data_b[index][2]
			}

			this.update()

            api.postData(
                {
                    type:"insert",
					data:{
						pageid:this.page,
						data:[
							this.column_data_a[this.selection][0],
							id,
							table,
							value,
							text,
						],
					}
                }
            ).then((res) => {

            })
		},
		async update(){
			let div_a = document.getElementById("div_a")
			let scroll_a = 0
			if(div_a!=undefined) scroll_a = div_a.scrollTop

			let div_b = document.getElementById("div_b")
			let scroll_b = 0
			if(div_b!=undefined) scroll_b = div_b.scrollTop

			let div_c = document.getElementById("div_c")
			let scroll_c = 0
			if(div_c!=undefined) scroll_c = div_c.scrollTop

			this.updateKey++;

			this.$nextTick(function () {
				this.setScroll(scroll_a,scroll_b,scroll_c)
			})
		},
		async setScroll(a,b,c){
			let div_a = document.getElementById("div_a")
			if(div_a!=undefined) div_a.scrollTop = a
			let div_b = document.getElementById("div_b")
			if(div_b!=undefined) div_b.scrollTop = b
			let div_c = document.getElementById("div_c")
			if(div_c!=undefined) div_c.scrollTop = c
		},

		editRole(value){
			if(value==0){
				this.edit_value = 0
				this.edit_dialogue_text = "Add Role"
				this.edit_html = this.edit_html_placeholder
				this.edit_html = this.edit_html.replace("\{{0}}", "")
			}else{

				this.edit_value = this.column_data_a[value][0]
				this.edit_dialogue_text = "Edit Role "+this.column_data_a[value][0]
				this.edit_html = this.edit_html_placeholder
				this.edit_html = this.edit_html.replace("\{{0}}", "value='"+this.column_data_a[value][2]+"'")
			}

			this.edit_dialogue = true
		},
		editDialogueCancel(){
			this.edit_dialogue = false
		},
		editDialogue(buttonname){
			if(buttonname == 'Accept'){
				var editText = document.getElementById("editText").value

				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.roleEditPage,
							data:[
								this.edit_value,
								editText
							],
						}
					}
				).then((res) => {
					this.search()
					this.update();
					this.editDialogueCancel()
				});
			}
		},
	},
	watch:{
		term(){
			if(this.separateSearch==false) this.search_term = this.term;
			if(this.termchange==true){
				this.search(true);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/layouts/layout_14.vue